const RouteMoochModel = {
    id: "",
    order: 0,
    mooch: true,
    mooched_at: null,
    cleared: false,
    cleared_at: null,
    island_id: null,
    island_data: {
        id: "",
        name: "",
        lat: "",
        lng: "",
        zone: "",
        full_address: "",
        uuids: [],
    },
    route_id: "",
    route_data: {
        id: "",
        name: "",
        dated: null,
        completed_at: null,
        driver: "",
    },
    unload_data: {
        status: "",
        order: 0,
    },
    unload_waypoint_id: "",
};

export default RouteMoochModel;
